// Anonymous per-device id, hashed with the calendar day so the stored value
// rotates daily and cannot link sessions across days. No PII.

const ID_KEY = "cl_vid_v1";

const randomId = (): string => {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return Math.random().toString(36).slice(2) + Date.now().toString(36);
};

const getOrCreateDeviceId = (): string => {
  if (typeof window === "undefined") return "ssr";
  try {
    let id = localStorage.getItem(ID_KEY);
    if (!id) {
      id = randomId();
      localStorage.setItem(ID_KEY, id);
    }
    return id;
  } catch {
    return randomId();
  }
};

const todayKey = () => {
  const d = new Date();
  return `${d.getUTCFullYear()}-${d.getUTCMonth() + 1}-${d.getUTCDate()}`;
};

const sha256Hex = async (input: string): Promise<string> => {
  const enc = new TextEncoder().encode(input);
  const buf = await crypto.subtle.digest("SHA-256", enc);
  return [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, "0")).join("");
};

let cached: { day: string; hash: string } | null = null;

/** Daily-rotating anonymous visitor hash (SHA-256 of deviceId + UTC date). */
export const getVisitorHash = async (): Promise<string> => {
  const day = todayKey();
  if (cached && cached.day === day) return cached.hash;
  const id = getOrCreateDeviceId();
  const hash = await sha256Hex(`${id}|${day}`);
  cached = { day, hash };
  return hash;
};

export const clearVisitorId = () => {
  if (typeof window === "undefined") return;
  try {
    localStorage.removeItem(ID_KEY);
  } catch {
    /* ignore */
  }
  cached = null;
};
